module.exports = __webpack_public_path__ + "static/img/box_star.d3eeebc4.png";